import { Box, Flex, Heading, Stack, Text, Image } from "@chakra-ui/react";
import { BuyButton } from "./../BuyButton";
import { GoToProductButton } from "./../GoToProductButon";
import riderImgLG from "./kolarz_bw_alone_lg.webp";
import riderImgMD from "./kolarz_bw_alone_md.webp";

export const ProductBookAd = ({
  product,
}: {
  product: {
    buyLink?: string;
    slugUrl: string;
  };
}) => {
  return (
    <Flex maxWidth={"90%"} margin={"auto"} px={4} flexWrap={"wrap"}>
      <Box flexBasis={{ base: "100%", md: "60%" }} order={{ base: 1 }}>
        <Heading
          as="h1"
          sx={{
            "-webkit-text-fill-color": "transparent",
            backgroundImage:
              "linear-gradient(45deg, #503F20 0%, #FB3436 50%, #F7A625 100%);",
            "-webkit-background-clip": "text",
          }}
          lineHeight={1.2}
          fontSize={"3xl"}
          mb={8}
          display={"inline-block"}
          fontWeight={"bold"}
          color={"primary.500"}
          rounded={4}
        >
          Start Wydawnictwa Dystans.
          <br />
          {`"Kolarz"`} Tima Krabbé -&nbsp;już dostępny!
        </Heading>
      </Box>
      <Box
        flexBasis={{ base: "100%", md: "40%" }}
        order={{ base: 2 }}
        height={{ base: "100%", md: "5px" }}
        justifySelf={"flex-end"}
      >
        <Image
          src={riderImgLG}
          srcSet={`${riderImgMD} 768w, ${riderImgLG} 992w`}
          alt="Kolarz - okładka książki"
          m={{ base: "auto", md: "inherit" }}
          maxW={{ base: "250px", md: "100%" }}
        />
      </Box>
      <Box flexBasis={{ base: "100%", md: "60%" }} order={3}>
        <Text
          fontSize={{ base: "xl", md: "3xl" }}
          fontWeight="normal"
          fontStyle={"italic"}
          textAlign={"left"}
        >
          “Dalej, wyżej, chłodniej. Moja klatka piersiowa i&nbsp;policzki płoną,
          a&nbsp;nogi mam czerwone jak&nbsp;cegła.”
        </Text>
      </Box>
      <Text
        flexBasis={{ base: "100%", md: "60%" }}
        order={4}
        py={12}
        lineHeight={1.5}
        fontSize={{ base: "md", md: "lg" }}
      >
        Premiera polskiego wydania absolutnego klasyka literatury sportowej,
        który niezmiennie od&nbsp;lat zyskuje nowych czytelników&nbsp;i
        inspiruje kolejne pokolenia. Ponad 300 000 sprzedanych egzemplarzy na
        świecie, przez wielu uznawany za najważniejsze dzieło o&nbsp;kolarstwie
        - {'"Kolarz"'} Tima Krabbé.
      </Text>
      <Stack
        flexBasis={{ base: "100%", md: "60%" }}
        order={5}
        direction={{ base: "column", md: "row" }}
        spacing={2}
        justifyContent={"center"}
      >
        <BuyButton
          productBuyPath={product.buyLink}
          text="Do koszyka za 49,90zł"
        />
        <GoToProductButton productPagePath={`/ksiazka/${product.slugUrl}`} />
      </Stack>
    </Flex>
  );
};
